import {
  Alert,
  Button,
  FormControl,
  InputLabel,
  Select,
  Slide,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React, { useContext, useState } from "react";
import { ClientContext } from "../../store/context";
import { keysApi, locationsApi } from "../api/GardenoApi";
import { usePost } from "../hooks/Hooks";
import "../styles/dateTimePickers.css";
import { dateBoxKeys } from "../utils/constants";
import {
  convertToLanguage,
  getMenuItems,
  getTimeRange,
  onChangeHandler,
} from "../utils/generalUtils";
import dayjs from "dayjs";

function Datebox({ onSearchClick }) {
  const {
    language,
    pickUpDate,
    setPickUpDate,
    dropOffDate,
    setDropOffDate,
    dropOffTime,
    setDropOffTime,
    dropOffLocation,
    setDropOffLocation,
    pickUpTime,
    setPickUpTime,
    pickUpLocation,
    setPickUpLocation,
  } = useContext(ClientContext);
  const [locations, locationsError] = usePost(
    locationsApi.getAllLocation,
    convertToLanguage(language),
    {}
  );
  const [keys, keysError] = usePost(
    keysApi.getAllKeys,
    convertToLanguage(language),
    dateBoxKeys
  );
  const [clicked, setClicked] = useState(false);
  return (
    <div style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}>
      <Paper className="datebox" elevation={8}>
        <div className="datebox-row">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={pickUpDate}
              onChange={setPickUpDate}
              disablePast
              className="datebox-date-item"
              label={keys?.settings?.CALENDAR_PICK_UP_DATE}
              format="DD/MM/YYYY"
            />
            <DatePicker
              value={dropOffDate}
              onChange={setDropOffDate}
              disablePast
              minDate={pickUpDate ? dayjs(pickUpDate).add(3, "day") : null}
              className="datebox-date-item"
              label={keys?.settings?.CALENDAR_DROP_OFF_DATE}
              format="DD/MM/YYYY"
            />
          </LocalizationProvider>
        </div>
        <div className="datebox-row">
          <div className="datebox-time_locations">
            <FormControl className="datebox-time_locations-item">
              <InputLabel id="demo-simple-select-label">
                {keys?.settings?.CALENDAR_PICKUP_UP_LOCATION}
              </InputLabel>

              <Select
                value={pickUpLocation}
                onChange={(event) => onChangeHandler(event, setPickUpLocation)}
                labelId={keys?.settings?.CALENDAR_PICKUP_UP_LOCATION}
                label={keys?.settings?.CALENDAR_PICKUP_UP_LOCATION}
              >
                {getMenuItems(locations?.map((item) => item.location))}
              </Select>
            </FormControl>
            <FormControl className="datebox-time_locations-item">
              <InputLabel id="demo-simple-select-label">
                {keys?.settings?.CALENDAR_PICKUP_UP_TIME}
              </InputLabel>
              <Select
                value={pickUpTime}
                onChange={(event) => onChangeHandler(event, setPickUpTime)}
                label={keys?.settings?.CALENDAR_PICKUP_UP_TIME}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 48 * 4.5 + 8,
                    },
                  },
                }}
              >
                {getMenuItems(
                  getTimeRange(
                    "07:00",
                    "00:00",
                    0.5
                    // keys?.settings?.SETTING.RESERVATION_BACKOFF
                  )
                )}
              </Select>
            </FormControl>
          </div>
          <div className="datebox-time_locations">
            <FormControl className="datebox-time_locations-item">
              <InputLabel id="demo-simple-select-label">
                {keys?.settings?.CALENDAR_DROP_OFF_LOCATION}
              </InputLabel>
              <Select
                value={dropOffLocation}
                onChange={(event) => onChangeHandler(event, setDropOffLocation)}
                label={keys?.settings?.CALENDAR_DROP_OFF_LOCATION}
              >
                {getMenuItems(locations?.map((item) => item.location))}
              </Select>
            </FormControl>
            <FormControl className="datebox-time_locations-item">
              <InputLabel id="demo-simple-select-label">
                {keys?.settings?.CALENDAR_DROP_OFF_TIME}
              </InputLabel>
              <Select
                value={dropOffTime}
                onChange={(event) => onChangeHandler(event, setDropOffTime)}
                label={keys?.settings?.CALENDAR_DROP_OFF_TIME}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 48 * 4.5 + 8,
                    },
                  },
                }}
              >
                {getMenuItems(
                  getTimeRange(
                    "07:00",
                    "00:00",
                    0.5
                    // keys?.settings?.SETTING.RESERVATION_BACKOFF
                  )
                )}
              </Select>
            </FormControl>
          </div>
        </div>
        <div
          className="datebox-last-row"
          style={{
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              if (
                pickUpDate &&
                pickUpLocation &&
                pickUpLocation &&
                dropOffDate &&
                dropOffLocation &&
                dropOffTime
              ) {
                onSearchClick();
              }
              setClicked(true);
            }}
            sx={{ backgroundColor: "#47B5FF", color: "#FFF" }}
          >
            {keys?.settings?.SEARCH}
          </Button>
        </div>
      </Paper>
      {clicked &&
        !(
          pickUpDate &&
          pickUpLocation &&
          pickUpLocation &&
          dropOffDate &&
          dropOffLocation &&
          dropOffTime
        ) && (
          <Slide
            direction="right"
            in={
              !(
                pickUpDate &&
                pickUpLocation &&
                pickUpLocation &&
                dropOffDate &&
                dropOffLocation &&
                dropOffTime
              )
            }
            sx={{ width: "60%", alignSelf: "center" }}
          >
            <Alert severity="error">
              Please fill the needed information for the reservation
            </Alert>
          </Slide>
        )}
    </div>
  );
}

export default Datebox;
